import type { Readable } from "node:stream";

import { projectPositionSummary } from "../kernel/projectors.js";
import {
  commitProofRecord,
  loadPositionForCommand,
} from "../kernel/board-engine.js";
import type { ExecutionContext } from "../runtime/context.js";
import type {
  ProofListRequest,
  ProofRecordRequest,
} from "../cli/protocol.js";

export async function handleProofRecord(
  context: ExecutionContext,
  request: ProofRecordRequest,
  stdin: Readable,
) {
  const result = await commitProofRecord(context, request.s, {
    bodySpec: request.b,
    fromPositionRef: request.p,
    proofId: request.f,
    stdin,
    targetAtomId: request.t,
    verdict: request.v,
  });

  return {
    board: result.board,
    parent: projectPositionSummary(result.parent),
    position: projectPositionSummary(result.position),
    proof: result.proof,
  };
}

export async function handleProofList(
  context: ExecutionContext,
  request: ProofListRequest,
) {
  const { position } = await loadPositionForCommand(context, request.s, request.p);
  return {
    position: projectPositionSummary(position),
    proofs: Object.values(position.stateSnapshot.atoms)
      .filter((atom) => atom.kind === "proof")
      .sort((left, right) => left.id.localeCompare(right.id)),
  };
}
